define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var RemovePhoneNumberModel = /** @class */ (function () {
        function RemovePhoneNumberModel(data) {
            this.Id = ko.observable(0);
            this.DeleteNumber = ko.observable(true);
            this.DeleteE911 = ko.observable(false);
            this.CanDeleteE911 = ko.observable(false);
            this.HasE911 = ko.observable(false);
            this.StatusName = ko.observable("");
            this.ReasonNotes = ko.observable("");
            this.ConfirmCode = ko.observable("");
            this.userCanDeleteBrekeke = ko.observable(false);
            this.deleteBrekeke = ko.observable(true);
            this.Numbers = ko.observableArray();
            this.NumbersIds = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, RemovePhoneNumberModel.Mapping, self);
            }
        }
        RemovePhoneNumberModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new RemovePhoneNumberModel(options.data);
            }
        };
        return RemovePhoneNumberModel;
    }());
    return RemovePhoneNumberModel;
});
//# sourceMappingURL=RemovePhoneNumberModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/RemovePhoneNumberModel.js
// module id = 192
// module chunks = 2